import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M14 8c1.8 0 3.321 1.188 3.824 2.823A2 2 0 0019 9a1 1 0 112 0 4.002 4.002 0 01-3 3.874L17.999 14H21a1 1 0 110 2h-3.084c-.076.453-.203.89-.377 1.308A4 4 0 0120 21a1 1 0 11-2 0 2 2 0 00-1.57-1.954A5.968 5.968 0 0114.4 20.5a1 1 0 01-1.4-.92V13a1 1 0 10-2 0v6.58a1 1 0 01-1.4.92 5.991 5.991 0 01-2.03-1.453A2 2 0 006 21a1 1 0 11-2 0 4.001 4.001 0 012.461-3.693A5.94 5.94 0 016.084 16H3a1 1 0 110-2h2.999v-1.126A4.002 4.002 0 013 9a1 1 0 112 0c0 .807.485 1.507 1.177 1.822A4 4 0 0110 8h4zm-2-6a5 5 0 013.73 1.67A2 2 0 0114.23 7H9.77a2 2 0 01-1.49-3.33h-.01A5 5 0 0112 2z",
      fill: "#2d6ded"
    }
  )
);
export {
  t as default
};
